import { WalmartEnvironmentConfig } from '@walmart/config';
import { TenantEntityIds, TenantAppOriginsByStage } from '@shared/config';

/**
 * Deployed QA environment for Walmart US
 */
export const environment: WalmartEnvironmentConfig = {
  /** TRUE to compile with production optimizations. FALSE to compile with more debugging options enabled. */
  production: true,

  /**
   * The base URL to access the APIs
   */
  apiUrl: 'https://qa.us.walmart.api.pulse.lumatrak.com',

  /** Base Auth API URL for this environment */
  authApiUrl: 'https://api.pulse.lumatrak.com',

  /** The base URL to the training material */
  trainingMaterialUrl: 'https://media.lumatrak.com/TrainingVideosUS/',

  /** The email address to use for support */
  supportEmailAddress: 'pulsesupport@lumatrak.com',

  twoMinuteTimeout: 120000,

  apiRetryAttempts: 2,

  tenantBusinessContact: 'Seth Whitaker',

  tenantBusinessContactEmail: 'Seth.Whitaker@walmart.com',

  analyticsEnv: 'qa',

  clarityKey: 'xg7kso6jg1',

  gaMeasurementId: 'G-MRT7K41PH3',

  tenantEntityId: TenantEntityIds.WalmartUs,

  tenantAppOrigins: TenantAppOriginsByStage.qa,
  accountSwitchEnabled: true,

  auth0Config: {
    domain: 'login.lumatrak.com',
    clientId: 'JshzYFCxOReDcSGQAbX3f95THJiiIaMQ',
    authorizationParams: {
      connection: 'PulseUsers-Dev',
      redirect_uri: 'https://qa.us.walmart.pulse.lumatrak.com/loading',
      audience: 'pulse-api',
      scope: 'access:auth access:walmart-us'
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true
  }
};
